module.exports = __webpack_public_path__ + "img/KV_v8_neoconf.ae46f89a.svg";